import React, { type FC } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

import { selectLicense, Translation } from '../../../../../domain'

import { LogoutReason } from '../../../../../application'

import { Button } from '../../../common'
import { FormattedTranslation } from '../../../Internationalization'
import { useAppState, useAppUsecases } from '../../../State'
import { Content } from './Content'
import { Title } from './Title'

export const Modal: FC = () => {
    const license = useAppState(selectLicense)
    const { logoutUsecase } = useAppUsecases()

    return (
        <Dialog data-testid="license-issues-modal" disableEscapeKeyDown open fullWidth maxWidth="md">
            <DialogTitle>
                <Title loading={!license} />
            </DialogTitle>
            <DialogContent dividers>
                <Content license={license} />
            </DialogContent>
            <DialogActions>
                <Button data-testid="license-check-modal-logout" variant="primary" onClick={() => logoutUsecase.logout(LogoutReason.MANUAL_LOGOUT)}>
                    <FormattedTranslation id={Translation.LOGOUT} />
                </Button>
            </DialogActions>
        </Dialog>
    )
}
